import React from 'react';
import Entry from '../entry';
import { Text } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = 'Frosty Keypad';
  const assignment = `Hey kid, it's me, Tangle Coalbox.
I'm sleuthing again, and I could use your help.
Ya see, this here number lock's been popped by someone.
I think I know who, but it'd sure be great if you could open this up for me.
I've got a few clues for you.\n
One digit is repeated once.\n
The code is a prime number.\n
You can probably tell by looking at the keypad which buttons are used.
Yep, that's it. Thanks for the assist, gumshoe.`;
  const data = useStaticQuery(graphql`
    query {
      cranKeypad: file(relativePath: { eq: "cranKeypad.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      keypadEasterEgg: file(relativePath: { eq: "keypadEasterEgg.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      keypadSuccess: file(relativePath: { eq: "keypadSuccess.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      termKeypadCode: file(relativePath: { eq: "termKeypadCode.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      keypadOnly: file(relativePath: { eq: "keypadOnly.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `);
  const extra = (
    <>
    <Img fluid={data.cranKeypad.childImageSharp.fluid}
            style={{ margin: 0,  maxHeight: '35vh', width: '72vw' }}
            imgStyle={{ objectFit: 'contain' }}
    />
    <Text mb={1} fontSize='13px' alignSelf='center'>Location: the Quad, entrance to Dormitory</Text>
    </>
  );

  return (
    <Entry
      title={title}
      extra={extra}
      hints={[]}
      assignment={assignment}
    >
      <Text my={2}>The codes to doors often have four digits. It looks like on the keypad digits 1, 3 and 7 have been pressed more ofte than others. </Text>
      <Img fluid={data.keypadOnly.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '35vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>Let's write some JavaScript code to find all prime numbers with four digits consisting of 1, 3 and 7. <a target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Sieve_of_Eratosthenes">Sieve of Eratosthenes</a> is a great algorithm for finding primes up to a certain number (limit).</Text>
      <Img fluid={data.termKeypadCode.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>When we run the code, it prints the options to try: <code>['1373', '1733', '3137', '3371', '7331' ]</code> . Code <code>7331</code> worked!</Text>
      <Img fluid={data.keypadSuccess.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={3}>A while after completing this challenge I discovered that the code was written on ther wall in the Dormitory. Maybe for people who got in not to forget? ¯\_(ツ)_/¯</Text>
      <Img fluid={data.keypadEasterEgg.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '50vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
    </Entry>
  )

};
